import { render, staticRenderFns } from "./especiespagamentos.vue?vue&type=template&id=630d552e&"
import script from "./especiespagamentos.vue?vue&type=script&lang=js&"
export * from "./especiespagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports